import React from "react"
import { OldButton } from "@kit/design/old-button"

export function SettingsButton(props) {
  return (
    <OldButton
      {...props}
      size="sm"
      is="secondary"
      className="ml-auto block"
      style={{ fontFamily: "var(--font-ui)", backgroundColor: "white" }}
      icon="settings-cog"
    >
      Settings
    </OldButton>
  )
}
